<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » メール送信タイトルダイアログの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>メール送信タイトルダイアログの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/send-mail-title-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> メール送信タイトル（メイン言語）
        </div>
        <div class="manual-explain">
          メール送信タイトルを設定します。<br>
          ユーザー予約が完了した時に送信されるメールのタイトルに利用されます。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> メール送信タイトル（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用のメール送信タイトルを設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> メール送信タイトル（他言語）
        </div>
        <div class="manual-explain">
          メール送信タイトルを設定します。<br>
          自動翻訳にチェックを入れることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Email Send Title Dialog
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Email Send Title Dialog</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_send-mail-title-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          The selected content will not be applied.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> All Languages Auto-Translation
        </div>
        <div class="manual-explain">
          Toggle ON/OFF for all language auto-translation checkboxes.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Email Send Title (Main Language)
        </div>
        <div class="manual-explain">
          Set the email send title.<br>
          Used for the title of emails sent when user reservations are completed.<br>
          The first language set in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> becomes the main language.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Email Send Title (For Translation)
        </div>
        <div class="manual-explain">
          Set the email send title for auto-translation.<br>
          Translations for each language will be performed based on the content set here.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Email Send Title (Other Languages)
        </div>
        <div class="manual-explain">
          Set the email send title.<br>
          Translation processing will be executed by checking auto-translation. (Set content will be overwritten by the translation process)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to apply the edited content.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
